import {buildUniqueId} from '../utils/build-unique-id';

import type {LimitsMap} from './typedef';
import type {ChangesInfo} from 'src/openapi/admin/models/ChangesInfo';
import type {LimitList} from 'src/openapi/admin/models/LimitList';
import type {AppState} from 'src/store/typedef';


type ContractLimitProps = {
    contractId: number,
};

export const getContractLimitsData = (state: AppState, {contractId}: ContractLimitProps): LimitList | null => {
    return state.apiv2.limits.contractData?.[contractId] || null;
};

export const getContractChangesInfo = (state: AppState, props: ContractLimitProps): ChangesInfo | null => {
    return getContractLimitsData(state, props)?.changesInfo || null;
};

export const makeGetContractLimitsWithIds = (state: AppState, params: ContractLimitProps): LimitsMap => {
    const limitsData = getContractLimitsData(state, params);

    if (limitsData) {
        return limitsData.limits.reduce((withIds, limit) => {
            withIds[buildUniqueId(limit)] = limit;
            return withIds;
        }, {} as LimitsMap);
    }
    return {};
};
